import React from "react";

export const SessionTimeContext = React.createContext<number>(
  new Date().valueOf()
);
